import { createContext, useContext, useState } from 'react';
import type { ReactNode } from 'react';

const ThemeContext = createContext({ dark: false, toggle: () => {} });
export function ThemeProvider({ children }: { children: ReactNode }) {
  const [dark, setDark] = useState(() => {
    try {
      return localStorage.getItem('wf.theme') === 'dark';
    } catch {
      return false;
    }
  });
  function toggle() {
    setDark((current) => {
      try {
        localStorage.setItem('wf.theme', current ? 'light' : 'dark');
      } catch {
        /* Storage is optional. */
      }
      return !current;
    });
  }
  return (
    <ThemeContext.Provider value={{ dark, toggle }}>
      <div data-theme={dark ? 'dark' : 'light'}>{children}</div>
    </ThemeContext.Provider>
  );
}
export function ThemeToggle() {
  const { dark, toggle } = useContext(ThemeContext);
  return (
    <button
      className="wf-theme-toggle"
      onClick={toggle}
      type="button"
      aria-label={dark ? 'Use light theme' : 'Use dark theme'}
    >
      {dark ? '☀' : '☾'}
    </button>
  );
}
